import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import { faker } from "@faker-js/faker";

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

export const options = {
  responsive: true,
  plugins: {
    legend: {
      position: "top",
    },
    title: {
      display: true,
      text: "Chart.js Bar Chart",
    },
  },
};

const labels = ["January", "February"];

export const data = {
  labels: labels,
  datasets: [
    {
      label: "Dataset 1",
      data: [2, 0],
      backgroundColor: "rgba(255, 99, 132, 0.5)",
    },
    {
      label: "Dataset 2",
      data: [0, 1],
      backgroundColor: "rgba(53, 162, 235, 0.5)",
    },
  ],
};

console.log(data);

export const BarChart = () => {
  return <Bar options={options} data={data} />;
};

export default BarChart;
